<template>
    <div class="allcase">
        <div class="searchBox" v-if="showSearch">
            <el-input
                class="searchInput"
                size="small"
                v-model="title"
                @keyup.native="changeProductInfo"
                placeholder="输入关键字"
                suffix-icon="el-icon-search"
            >
            </el-input>
        </div>
        <div class="serviceListMessage_box">
            <div
                class="hotMesg_box"
                v-for="(item, index) in tableList"
                :key="index"
                @click="getCaseDetails(item.id)"
            >
            <p class="hotMesg_box_title ellipsis-2" >{{ item.title }}</p>
             <p
            class="hotMesg_icons"
            :style="{ backgroundImage: `url(${imgs1})` }"
            v-if="item.review == 3"
            >
            优质案例
            </p>
            <div class="hotMesg_box_content">
                <p>
                    <span>一级分类：</span>
                    <span>{{ item.cdClassOneName }}</span>
                </p>
                <p>
                    <span>案例价格：</span>
                    <span class="red">{{ item.price }}</span>
                </p>
                </div>
            </div>
        </div>
        <div v-if="tableList.length==0" style="text-align:center;margin-bottom:20px" >
                <img src="../../assets/暂无内容.jpg" alt="" style="width:200px">
        </div>
        <div style="text-align: right" v-if="showPage">
            <el-pagination
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next"
                :current-page="current"
                :page-size="pageSize"
                :total="total"
                class="pagination"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        showSearch:{
        type:Boolean,
        default:true
        },
        tableList:{
        type:Array,
        default:[]
        },
        showPage:{
        type:Boolean,
        default:true
        },
        total:{
        type:Number,
        default:0,
        }
    },
    data(){
        return {
          title:'',
            current:1,
            pageSize:10,
            imgs1: require("@/assets/supplyHome/green.jpg"),
        }
    },
    methods:{
        changeProductInfo() {
            this.current = 1;
            this.$emit('caseQueryChange',{current:this.current,pageSize:this.pageSize,title:this.title})
        },
        handleCurrentChange(val) {
            this.current = val;
            this.$emit('caseQueryChange',{current:this.current,pageSize:this.pageSize,title:this.title})
        },
      getCaseDetails(id) {
        let routeData = this.$router.resolve({
          name: "caseDetails",
          params: { uuid: id },
          query:{type:'buttJoint'}
        });
        window.open(routeData.href, "_blank");
      },
    }
}
</script>

<style lang="less" scoped>
.allcase{
    margin-top: 30px;
    .searchBox {
    background-color: #fafcff;
    height: 50px;
    line-height: 50px;
    margin: 30px 0 15px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 20px;
    .searchInput {
      width: 20%;
    }
    .searchInput /deep/ .el-input__inner {
      border-radius: 30px;
    }

    /deep/ .el-form-item {
      margin-bottom: 0;
    }

    /deep/ .el-form-item__label {
      line-height: inherit;
    }

    /deep/ .el-form-item__content {
      line-height: inherit;
    }

    .el-cascader /deep/ .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }
  .serviceListMessage_box {
    display: grid;
    grid-template-columns: 33% 33% 33%;
    grid-gap: 8px;
    margin-bottom: 40px;
  }
  .hotMesg_box_title {
      font-size: 16px;
      padding: 12px 20px 0 14px;
      font-weight: 600;
      color: #333333;
    }
  .hotMesg_box {
    border-radius: 4px;
    background: #fff;
    position: relative;
    cursor: pointer;
    .hotMesg_icons {
      position: absolute;
      right: -6px;
      top: 50%;
      background-size: 100% 100%;
      padding: 3px 15px;
      font-size: 12px;
      color: #fff;
    }
  }
  .hotMesg_box_content {
      font-size: 14px;
      padding: 8px 12px 0;
      line-height: 32px;
      color: #333333;
        border-top: 1px solid #ededed;
      margin-top: 10px;
      .red {
        color: #d9001b;
      }
    }
}
.ellipsis-2 {
  overflow: hidden;
   display: -webkit-box;
   -webkit-line-clamp: 2; /* 设置最大显示行数 */
   -webkit-box-orient: vertical;
   text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/print/allCase.vue